import {
  Button,
  Card,
  Col,
  DatePicker,
  Flex,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Table,
  Typography,
} from 'antd';
import React, { useEffect, useState } from 'react';
import IntlMessage from '../../../components/IntlMessage';
import { SearchOutlined } from '@ant-design/icons';
import customersApi from '../../../api/customers';
import useTime from '../../../hooks/useTime';
import dayjs from 'dayjs';
import reportApi from '../../../api/report';
import { formatCurrency, formatNumber } from '../../../helpers/helpers';
import { debounce } from 'lodash';
import ModalInfo from './ModalInfo';
import ModalOrder from './ModalOrder';
import { isMobile } from 'react-device-detect';

const { Text } = Typography;
const fs_16 = {
  fontSize: '16px',
};
const { Option } = Select;
const Report = () => {
  const [form] = Form.useForm();
  const { formatAsISOString } = useTime();
  const [filter, setFilter] = useState({
    // from_date: dayjs().startOf('month').toISOString(),
    // to_date: dayjs().endOf('month').toISOString(),
    customer_id: null,
  });
  const [filterCashier, setFilterCashier] = useState({
    page: 1,
    limit: 40,
    order_by: 'firstname',
    order_dir: 'ASC',
  });
  const [cashier, setCashier] = useState([]);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState({
    today: {
      total_today: 0,
    },
    total_pending: 0,
    total_paid: 0,
    total_cancelled: 0,
    total: null,
  });
  const [mode, setMode] = useState('date');
  const [item, setItem] = useState({});
  const [modalInfo, setModalInfo] = useState(false);
  const [modalOrder, setModalOrder] = useState(false);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const res = await reportApi.getCashierReport(filter);
        if (res && Array.isArray(res.data)) {
          setItems(res.data);
          setTotal({
            today: {
              total_today: res?.today?.total_today,
            },
            total_pending: res?.extra?.total_pending,
            total_paid: res?.extra?.total_paid,
            total_cancelled: res?.extra?.total_cancelled,
            total: res?.total,
          });
          setLoading(false);
        } else {
          setCashier([]);
        }
      } catch (error) {
        setLoading(false);
      }
    }

    fetchData();
  }, [filter]);

  useEffect(() => {
    async function fetchData() {
      const res = await reportApi.getCashierReportCustomers(filterCashier);
      if (res) {
        setCashier(
          res?.map((item) => {
            return {
              value: item?.userOperator?.id,
              label:
                item?.userOperator?.user?.firstname +
                ' ' +
                item?.userOperator?.user?.lastname,
            };
          })
        );
      } else {
        setCashier([]);
      }
    }

    fetchData();
  }, [filterCashier]);

  const onSearch = () => {
    form
      .validateFields()
      .then((values) => {
        setFilter({
          ...values,
          // from_date:
          //   mode === 'date'
          //     ? values.from_date?.toISOString()
          //     : values.from_date?.startOf(mode)?.toISOString(),
          // to_date:
          //   mode === 'date'
          //     ? values.to_date.toISOString()
          //     : values.from_date?.endOf(mode).toISOString(),
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const onSearchCashier = debounce((value) => {
    setFilterCashier((filter) => {
      return {
        ...filter,
        keyword: value,
      };
    });
  }, 500);

  const onChangeMode = (value) => {
    setMode(value);
    // setFilter({
    //   mode: value,
    //   from_date: dayjs().startOf(value).toISOString(),
    //   to_date: dayjs().endOf(value).toISOString(),
    // });
    form.setFieldsValue({
      from_date: mode === 'date' ? dayjs().startOf('M') : dayjs(),
      to_date: mode === 'date' ? dayjs().endOf('M') : dayjs(),
    });
  };

  const onOpenModalInfo = (record) => {
    setModalInfo(true);
    setItem(record);
  };

  const onCloseModalInfo = (record) => {
    setModalInfo(false);
  };

  const onOpenModalOrder = (record) => {
    setModalOrder(true);
    setItem(record);
  };

  const onCloseModalOrder = (record) => {
    setModalOrder(false);
  };

  const columns = [
    {
      key: 'agent_name',
      title: <IntlMessage id="global.name" />,
      width: isMobile ? 100 : 300,
      fixed: 'left',
      render: (text, record) => {
        return (
          <Space direction="vertical" size={2}>
            <span
              style={{ color: '#1677ff', cursor: 'pointer' }}
              onClick={() => onOpenModalInfo(record)}>
              {record?.userOperator?.user?.firstname +
                ' ' +
                record?.userOperator?.user?.lastname}
            </span>
            {Number(record?.total_paid_detail) > 0 && (
              <Text style={{ color: 'red', padding: '4px 0px' }}>
                {formatCurrency(Number(record?.total_paid_detail || 0))}
              </Text>
            )}
          </Space>
        );
      },
    },
    {
      key: 'closing',
      title: <IntlMessage id="global.closing" />,
      render: (text, record) => {
        const date = dayjs(record?.close_date);
        return (
          <Space direction="vertical">
            <Text>{date.format('DD/MM/YYYY')}</Text>
            <Text>{date.format('HH:mm')}</Text>
          </Space>
        );
      },
    },
    {
      key: 'total',
      title: 'Total',
      render: (text, record) => {
        return formatCurrency(
          Number(record?.total_paid_tickets) +
            Number(record?.data_luggage_summary?.global_total?.total || 0)
        );
      },
    },
    {
      key: 'first_date_time',
      title: <IntlMessage id="global.first_sale" />,
      render: (text, record) => {
        const date = dayjs(record?.first_date);
        return (
          <Space direction="vertical">
            <Text>{record?.order_first_sale?.order_no}</Text>
            <Text>{date.format('DD/MM/YYYY')}</Text>
            <Text>{date.format('HH:mm')}</Text>
          </Space>
        );
      },
    },
    {
      key: 'last_date_time',
      title: <IntlMessage id="global.last_sale" />,
      render: (text, record) => {
        const date = dayjs(record?.last_date);
        return (
          <Space direction="vertical">
            <Text>{record?.order_last_sale?.order_no}</Text>
            <Text>{date.format('DD/MM/YYYY')}</Text>
            <Text>{date.format('HH:mm')}</Text>
          </Space>
        );
      },
    },
    // {
    //   key: 'total_paid',
    //   title: '#Paid',
    //   render: (text, record) => {
    //     return formatNumber(record?.paid_tickets);
    //   },
    // },
    // {
    //   key: 'not_paid_tickets',
    //   title: '#Not paid',
    //   render: (text, record) => {
    //     return formatNumber(record?.not_paid_tickets);
    //   },
    // },
    // {
    //   key: 'cancelled_tickets',
    //   title: 'Cancelled',
    //   render: (text, record) => {
    //     return (
    //       <Space direction="vertical">
    //         <Text>{record?.cancelled_tickets}</Text>
    //         {record?.total_cancelled_tickets > 0 && (
    //           <Text>{formatCurrency(record?.total_cancelled_tickets)}</Text>
    //         )}
    //       </Space>
    //     );
    //   },
    // },

    {
      key: 'btn',
      title: '',
      render: (text, record) => {
        return (
          <Button
            shape="round"
            size="small"
            type="primary"
            onClick={() => onOpenModalOrder(record)}>
            <IntlMessage id="global.liste" />
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Flex justify="start">
            <Form form={form} onFinish={onSearch}>
              <Row justify={'start'}>
                <Col>
                  <Form.Item
                    name={'customer_id'}
                    // initialValue={'date'}
                    rules={[
                      {
                        required: false,
                        message: <IntlMessage id="global.requiredfeild" />,
                      },
                    ]}>
                    <Select
                      showSearch
                      style={{
                        minWidth: 200,
                      }}
                      //onChange = {handleChangeCurrency}
                      allowClear
                      placeholder="Caissier"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }>
                      {cashier.map((option, index) => {
                        return (
                          <Option
                            key={`${option.value}_${index}`}
                            value={option?.value}>
                            {option?.label}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>

                <Col>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Filtrer
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Flex>
        </Col>
        <Col span={24}>
          <Flex justify="center">
            <Card style={{ height: '100%', minWidth: '300px' }}>
              <Space
                direction="vertical"
                style={{ width: '100%', textAlign: 'center' }}>
                <Text>
                  <IntlMessage id="global.pending" />
                </Text>
                <Text strong style={fs_16} textAlign="center">
                  <Text style={{ color: 'red' }}>
                    {formatCurrency(total?.total_pending)}
                  </Text>
                </Text>
                {/* <Flex justify="space-between" wrap>
                  <Text>(Tod) </Text>
                  <Text strong style={fs_16}>
                    {formatNumber(total?.today?.total_today || 0)}
                  </Text>
                </Flex> */}
                {/* <Flex justify="space-between" wrap>
                  <Text>
                    ({dayjs(filter.from_date).format('MMM DD')} -{' '}
                    {dayjs(filter.to_date).format('MMM DD')}){' '}
                  </Text>
                  <Text strong style={fs_16} textAlign="c">
                    <Text>{formatCurrency(total?.total)}</Text>
                  </Text>
                </Flex> */}
              </Space>
            </Card>
          </Flex>
        </Col>
        <Col span={24}>
          <Table
            dataSource={items}
            columns={columns}
            tableLayout="auto"
            loading={loading}
            bordered
            scroll={{ x: 'max-content' }}
            rowKey="id"
            size="small"
          />
        </Col>
      </Row>
      {modalInfo && (
        <ModalInfo open={modalInfo} onClose={onCloseModalInfo} item={item} />
      )}
      {modalOrder && (
        <ModalOrder
          open={modalOrder}
          onClose={onCloseModalOrder}
          item={item}
          filter_value={filter}
        />
      )}
    </>
  );
};

export default Report;
